import { RefTextInput } from "@/ui/atoms/TextInput"
import { FieldDefinition } from "../../types"
import { RefTextArea } from "@/ui/atoms/TextArea"
import { UseFormRegister } from "react-hook-form"

export interface CustomFormFieldProps {
  definition: FieldDefinition
  registerField: UseFormRegister<any>
}

const CustomFormField = ({
  definition,
  registerField,
}: CustomFormFieldProps) => {
  const commonProps = {
    placeholder: definition.placeholder,
    fullWidth: true,
    ...registerField(definition.name),
  }

  if (definition.type === "textArea") {
    return <RefTextArea rows={2} {...commonProps} />
  }
  return <RefTextInput {...commonProps} />
}

export default CustomFormField
